import { render, staticRenderFns } from "./jb-active-chip.vue?vue&type=template&id=fce9353c"
import script from "./jb-active-chip.vue?vue&type=script&lang=ts"
export * from "./jb-active-chip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce9353c')) {
      api.createRecord('fce9353c', component.options)
    } else {
      api.reload('fce9353c', component.options)
    }
    module.hot.accept("./jb-active-chip.vue?vue&type=template&id=fce9353c", function () {
      api.rerender('fce9353c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/jb-active-chip.vue"
export default component.exports